import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  fetchSystemsData } from '../../utils/apiCommonMethods';

// createSlice - initial state + reducers + actioncreators
// createAsyncThunk - Used to create an async action like api calls 
// with built-in lifecycle actions.


// Createa a systems/fetchSystems thunk containing 3 actions: pending, fulfilled, rejected
// This thunk will be used to fetch system data from the API if returns data -> trigger fulfilled action
// if it fails -> trigger rejected action with error message
export const fetchSystems = createAsyncThunk(
  'systems/fetchSystems',
  async (msSessionInfo, { rejectWithValue }) => {
    try {
      const data = await fetchSystemsData(msSessionInfo);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);


const systemsSlice = createSlice({
  name: 'systems',
  initialState: {
    data: [],
    loading: false,
    error: null,
    fetched: false,
  },
  reducers: {
    clearSystems: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystems.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.sort((a, b) => (a.name > b.name ? 1 : -1));;
        state.fetched = true;
      })
      .addCase(fetchSystems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSystems } = systemsSlice.actions;
export default systemsSlice.reducer;
